<footer>
  <div class="social-media-container">
    <h2>Lorem ipsum dolor sit amet.</h2>

    <ul>
      <li>
        <a href="http://facebook.com" target="_blank">
          <i class="fab fa-facebook"></i>
        </a>
      </li>
      <li>
        <a href="http://twitter.com" target="_blank">
          <i class="fab fa-twitter"></i>
        </a>
      </li>
      <li>
        <a href="http://linkedin.com" target="_blank">
          <i class="fab fa-linkedin"></i>
        </a>
      </li>
      <li>
        <a href="http://youtube.com" target="_blank">
          <i class="fab fa-youtube"></i>
        </a>
      </li>
    </ul>
  </div>

  <p class="copyright">
    {{ year }}
  </p>
</footer>
